<script setup>
const { features } = useFeatures()
const { r } = useRoutes()

function redirectToLegacyAppointments() {
  window.location.href = r({ path: '/appointment_types', isV2Path: false })
}

if (!features.customer_appointments_v2)
  redirectToLegacyAppointments()
</script>

<template>
  <AppointmentListPage />
</template>
